import { Fragment, useMemo } from 'react';
import PropTypes from 'prop-types';

export const Truncate = ({ children, maxChars = 100 }) => {
  const processed = useMemo(
    () =>
      typeof children === 'string'
        ? children.length > maxChars
          ? `${children.slice(0, maxChars)}...`
          : children
        : children,
    [children, maxChars]
  );

  return <Fragment>{processed}</Fragment>;
};

Truncate.propTypes = {
  maxChars: PropTypes.number.isRequired,
};
